import { FC, memo } from 'react'

import s from './ConfirmMessage.module.scss'

import { CustomButton } from 'components/UI/CustomButton/CustomButton'

import { ModalFullScreen } from 'components/UI/ModalFullScreen/ModalFullScreen'

interface AppMessageProps {
  message: string
  isOpen: boolean
  handleClose: () => void
  deleteItem: (id: number) => void
  id: number
}

const ConfirmMessage: FC<AppMessageProps> = memo(({ message, handleClose, deleteItem, id, isOpen }) => {

  const deleteButtonHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    deleteItem(id)
    handleClose()
  }

  return isOpen ? (
    <ModalFullScreen onHide={handleClose}>
      <div className={s.infoWrapper}>
        <span className={s.message}>{message}</span>
        <div className={s.buttons}>
          <CustomButton variant="outlined" type="submit" onClick={handleClose} size="180">
            Cancel
          </CustomButton>
          <CustomButton variant="danger" type="submit" onClick={(e) => deleteButtonHandler(e)} size="152">
            Delete
          </CustomButton>
        </div>
      </div>
    </ModalFullScreen>
  ): null
})

export default ConfirmMessage
